import { render } from "./InfoLabel.vue?vue&type=template&id=3096e596&scoped=true"
import script from "./InfoLabel.vue?vue&type=script&lang=js"
export * from "./InfoLabel.vue?vue&type=script&lang=js"

import "./InfoLabel.vue?vue&type=style&index=0&id=3096e596&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3096e596"]])

export default __exports__